export const JUMPED_POST_VIDEO_FRAME = "JUMPED_POST_VIDEO_FRAME";
export const SET_UPCOMING_ACTION_INDEX = 'SET_UPCOMING_ACTION_INDEX'
export const STARTED_FETCHING_COMBO = 'STARTED_FETCHING_COMBO'
export const FINISHED_FETCHING_COMBO = 'FINISHED_FETCHING_COMBO'
export const SET_ANIMATION_SPEED = 'SET_ANIMATION_SPEED'
export const SET_ACTIVATED_BY_USER = 'SET_ACTIVATED_BY_USER'